import React from "react"
import VersusPage from "../../templates/hotels/VersusPage"

const Page = () => <VersusPage duelKey="borgoVsComo" locale="fr" />

export default Page
